import type { ComponentProps } from 'react';

export const EditIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        clipRule='evenodd'
        d='M16.5422 2.70732L15.8352 2L15.1279 2.70717L4.29293 13.5412L4 13.8341V14.2483V17.0663V18.0663H5H7.818H8.23221L8.52511 17.7734L19.3591 6.93941L20.0661 6.23243L19.3592 5.52532L16.5422 2.70732ZM6 16.0663V14.6625L15.8348 4.82861L17.2379 6.23218L7.40379 16.0663H6ZM5 20.0667H4V22.0667H5H19H20V20.0667H19H5Z'
        fill='white'
        fillRule='evenodd'
      />
    </svg>
  );
};
